import React from "react";
import axios from "axios";
import { Dialog, DialogTitle, Slide } from "@mui/material";
import { Close } from "@mui/icons-material";
import { withStyles } from "tss-react/mui";
import Button from "../../../components/CustomButtons/Button";
import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import { toast } from "react-toastify";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class PartialRefund extends React.Component {
  emailInput = React.createRef();

  state = {
    saving: false,
    bestelling: {},
    loading: true,
    canSendEmail: false,
    refunding: false,
  };

  handleRefund = () => {
    this.setState({ refunding: true }, () => {
      axios
        .post("core/payments/refund", {
          id: this.props.bestellingId,
          hash: this.state.bestelling.orderHash,
        })
        .then((response) => {
          toast.success("Payment refunded.");
          this.loadBestelling();
          this.props.refreshJamezzTable();
        });
    });
  };

  /**
   * Get financial format
   */
  getNumberformat(value, currency = "EUR") {
    return new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: currency.toUpperCase(),
      currencyDisplay: "symbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  render() {
    const { classes } = this.props;
    /*   var paymentObject =
          this.state.bestelling.paymentDetails && this.state.bestelling.paymentDetails.statusSuccess !== undefined
            ? this.state.bestelling.paymentDetails.statusSuccess.report
            : null;
        let refundableAmount =
          this.state.bestelling !== undefined && this.state.bestelling && this.state.bestelling.metadata !== undefined
            ? (this.state.bestelling.metadata.orderValue * 100 - this.state.bestelling.refunded) / 100
            : 0; */
    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth={true}
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
        scroll={"paper"}
      >
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={this.props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <table>
            <tbody>
              <tr>
                <td>
                  <img src={"/img/jamezzPayments.png"} style={{ width: "110px", marginTop: "0px" }} />
                </td>
                <td>
                  <h1> | #{this.state.bestelling.id}</h1>
                </td>
              </tr>
            </tbody>
          </table>
        </DialogTitle>
        {/* {!this.state.loading ? (
          <div>
            <DialogTitle id="notice-modal-slide-title" disableTypography className={classes.modalHeader}>
              <Button
                justIcon
                className={classes.modalCloseButton}
                key="close"
                aria-label="Close"
                color="transparent"
                onClick={this.props.toggle}
              >
                <Close className={classes.modalClose} />
              </Button>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <img src="/img/jamezzPayments.png" style={{ width: "110px", marginTop: "0px" }} />
                    </td>
                    <td>
                      <h1> | #{this.state.bestelling.id}</h1>
                    </td>
                  </tr>
                </tbody>
              </table>
            </DialogTitle>
            {this.state.bestelling.parent_id ? (
              <div align="center">
                <div align="center" style={{ color: "red", maxWidth: "80%" }}>
                  <h3 style={{ fontSize: "100%", fontWeight: "600", marginTop: "0px" }}>
                    <TranslationWrapper
                      tKey={"bestellingen.modal.paymentdetail.text.partialPayment"}
                      tDefault={
                        "Pay attention! This payment is part of a partial order, you can only refund the part of the order placed in this partial order."
                      }
                    />
                  </h3>
                </div>
              </div>
            ) : null}
            <DialogContent id="notice-modal-slide-description" className={classes.modalBody}>
              <GridContainer>
                <GridItem md={2}>
                  {
                    <TranslationWrapper
                      tKey={"bestellingen.modal.paymentdetail.text.payment"}
                      tDefault={"Payment details"}
                    />
                  }
                </GridItem>
                <GridItem md={10}>{this.renderRecursive(paymentObject)}</GridItem>
              </GridContainer>
              {refundableAmount > 0 && !this.state.bestelling.splitOrder ? (
                <GridContainer>
                  <GridItem md={2}>
                    <div style={{ marginTop: "16px" }}>
                      {
                        <TranslationWrapper
                          tKey={"bestellingen.modal.paymentdetail.text.paymentActions"}
                          tDefault={"Payment acties"}
                        />
                      }
                    </div>
                  </GridItem>
                  <GridItem md={4}>
                    {this.state.refunding ? (
                      <React.Fragment>
                        <CircularProgress
                          style={{
                            width: "30px",
                            height: "30px",
                            position: "relative",
                            top: "10px",
                            marginRight: "10px",
                          }}
                        />
                        <h3
                          style={{
                            fontSize: "100%",
                            fontWeight: "600",
                            marginTop: "0px",
                            display: "inline",
                            color: "#ff0000",
                          }}
                        >
                          Processing refund ...
                        </h3>
                      </React.Fragment>
                    ) : (
                      <Button
                        color={"warning"}
                        onClick={this.handleRefund}
                        style={{ width: "100%" }}
                        disabled={this.state.refunding}
                      >
                        <React.Fragment>
                          <TranslationWrapper
                            tKey={"bestellingen.modal.paymentdetail.text.refund"}
                            tDefault={"Refund complete payment"}
                          />
                          {this.getNumberformat(refundableAmount, this.state.bestelling.vestiging.valuta)}
                        </React.Fragment>
                      </Button>
                    )}
                  </GridItem>
                  <GridItem md={4}>
                    {!this.state.refunding ? (
                      <Button
                        color={"info"}
                        onClick={this.handlePartialRefund}
                        style={{ width: "100%" }}
                        disabled={this.state.refunding}
                      >
                        {
                          <TranslationWrapper
                            tKey={"bestellingen.modal.paymentdetail.text.refund.partial"}
                            tDefault={"Partial refund"}
                          />
                        }
                      </Button>
                    ) : null}
                  </GridItem>
                </GridContainer>
              ) : null}
            </DialogContent>
          </div>
        ) : (
          <div style={{ margin: "25px auto" }}>
            <CircularProgress />
          </div>
        )} */}
      </Dialog>
    );
  }
}

export default withStyles(PartialRefund, notificationsStyle);
